'use strict';

export default class Slide {

    constructor(slideDom) {
        this.slideDom = slideDom;
        this.dreson = slideDom.getAttribute("data-promo-dreson");
        this.urlPath = slideDom.querySelector("a").getAttribute("href");
    }

    getDreson() {
        return this.dreson;
    }

    getUrlPath() {
        return this.urlPath;
    }

    setIsTracked() {
        this.slideDom.setAttribute("data-slidetracked", 'true');
    }

    isTracked() {
        this.slideDom.getAttribute("data-slidetracked");
    }

}